// extracted by mini-css-extract-plugin
export default {"container":"Rbottom_container__MvDwj","head":"Rbottom_head__0UYqS","card":"Rbottom_card__ZMvPL"};